"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
const react_intl_1 = require("react-intl");
exports.messages = (0, react_intl_1.defineMessages)({
    existingPayments: {
        id: 'components/Reservation/AdminPayment:existingPayments',
        defaultMessage: 'Existing payments',
    },
    debitTitle: {
        id: 'components/Reservation/AdminPayment:debitTitle',
        defaultMessage: 'Debit on account',
    },
    priceToPayTitle: {
        id: 'components/Reservation/AdminPayment:priceToPayTitle',
        defaultMessage: 'Price to pay',
    },
});
//# sourceMappingURL=messages.js.map